import { TFunction } from 'i18next';

import {
  catalanaOccidenteTheme,
  gesSegurosTheme,
  helvetiaTheme,
  mgsTheme,
  plusUltraTheme,
  realeTheme,
  segurosBilbaoTheme,
  theme,
  unionAlcoyanaTheme,
  caserTheme,
  fiatcTheme,
} from '../global-styles/colors';
import { CraneTrackingStep } from '../containers/common/service/service-types';
import { images } from '../assets/images/images';
import OCC_ICON_ES from '../assets/images/idiomas-texto-es.png';
import OCC_ICON_EN from '../assets/images/idiomas-texto-en.png';
import OCC_ICON_CA from '../assets/images/idiomas-texto-ca.png';
import { icons } from '../assets/icons/icons';

const DATE_FORMAT = 'DD/MM/YYYY';
const TIME_FORMAT = 'HH:mm';
const TIMEZONE = 'Europe/Madrid';

const SPECIALS_PLATES: { [key: string]: string } = {
  CME: "Corps of the Mossos d'Esquadra",
  DGP: 'Spanish Police',
  CNP: 'Spanish Police',
  E: 'Autonomous police force of the Basque Country',
  EA: 'Air Force',
  ET: 'Spanish Army',
  FAE: 'Allied Forces in Spain',
  FN: 'Spanish Navy',
  GSH: 'Colonial police on Sahara',
  PGC: 'Spanish civil guard',
  MF: 'Public Works Ministry',
  MMA: 'Environment Ministry',
  MOP: 'Public Works Ministry',
  PME: 'State owned vehicles',
  PMM: 'State owned vehicles, on a Ministry',
  CROWN: "King's Car",
};

const ASITUR_CODE = '00000016';

export type InsuranceCompany = {
  value: string;
  text: string;
  img: string;
  alt: string;
  theme?: any;
  phone: string;
  nameCode?: string;
  legal?: string;
  privacy?: string;
  cookies?: string;
  webParam?: string;
};

export type ManufacterBrand = {
  value: string;
  text: string;
};

export type Language = 'es' | 'en' | 'ca';
const DEFAULT_LANGUAGE: Language = 'es';
const SUPPORTED_LANGUAGES: Language[] = ['es', 'en', 'ca'];

const getSupportedLanguages = (t: TFunction<string[] | string>, provider: string | undefined = undefined) => {
  const isOccident = provider === '00000002';

  return {
    en: {
      icon: isOccident ? OCC_ICON_EN : icons.flagUKIcon,
      value: 'en',
      text: t('common:languages.english'),
    },
    es: {
      icon: isOccident ? OCC_ICON_ES : icons.flagSpainIcon,
      value: 'es',
      text: t('common:languages.spanish'),
    },
    ca: {
      icon: isOccident ? OCC_ICON_CA : icons.flagCatIcon,
      value: 'ca',
      text: t('common:languages.catalan'),
    },
  };
};

const MANUFACTERS_BRANDS: { [key: string]: ManufacterBrand } = {
  ABARTH: {
    value: 'ABARTH',
    text: 'ABARTH',
  },
  AEON: {
    value: 'AEON',
    text: 'AEON',
  },
  AIXAM: {
    value: 'AIXAM',
    text: 'AIXAM',
  },
  AIYUMO: {
    value: 'AIYUMO',
    text: 'AIYUMO',
  },
  'ALFA ROMEO': {
    value: 'ALFA ROMEO',
    text: 'ALFA ROMEO',
  },
  'ALPINA RENANIA': {
    value: 'ALPINA RENANIA',
    text: 'ALPINA RENANIA',
  },
  ALTAIR: {
    value: 'ALTAIR',
    text: 'ALTAIR',
  },
  APREAMARE: {
    value: 'APREAMARE',
    text: 'APREAMARE',
  },
  APRILIA: {
    value: 'APRILIA',
    text: 'APRILIA',
  },
  ARCOA: {
    value: 'ARCOA',
    text: 'ABAARCOARTH',
  },
  'ARCTIC CAT': {
    value: 'ARCTIC CAT',
    text: 'ARCTIC CAT',
  },
  'ARIA YACHTS': {
    value: 'ARIA YACHTS',
    text: 'ARIA YACHTS',
  },
  ARO: {
    value: 'ARO',
    text: 'ARO',
  },
  'ASIA MOTORS': {
    value: 'ASIA MOTORS',
    text: 'ASIA MOTORS',
  },
  ASKOLL: {
    value: 'ASKOLL',
    text: 'ASKOLL',
  },
  ASTEC: {
    value: 'ASTEC',
    text: 'ASTEC',
  },
  ASTINOR: {
    value: 'ASTINOR',
    text: 'ASTINOR',
  },
  'ASTON MARTIN': {
    value: 'ASTON MARTIN',
    text: 'ASTON MARTIN',
  },
  ASTONDOA: {
    value: 'ASTONDOA',
    text: 'ASTONDOA',
  },
  ASTROMAR: {
    value: 'ASTROMAR',
    text: 'ASTROMAR',
  },
  AUDI: {
    value: 'AUDI',
    text: 'AUDI',
  },
  AUSA: {
    value: 'AUSA',
    text: 'AUSA',
  },
  AUSTIN: {
    value: 'AUSTIN',
    text: 'AUSTIN',
  },
  PARKER: {
    value: 'PARKER',
    text: 'PARKER',
  },
  AUTHI: {
    value: 'AUTHI',
    text: 'AUTHI',
  },
  AUTOBIANCHI: {
    value: 'AUTOBIANCHI',
    text: 'AUTOBIANCHI',
  },
  AUTOCARAVANA: {
    value: 'AUTOCARAVANA',
    text: 'AUTOCARAVANA',
  },
  AUVERLAND: {
    value: 'AUVERLAND',
    text: 'AUVERLAND',
  },
  AVIA: {
    value: 'AVIA',
    text: 'AVIA',
  },
  AZEL: {
    value: 'AZEL',
    text: 'AZEL',
  },
  AZIMUT: {
    value: 'AZIMUT',
    text: 'AZIMUT',
  },
  BAOTIAN: {
    value: 'BAOTIAN',
    text: 'BAOTIAN',
  },
  BARFOR: {
    value: 'BARFOR',
    text: 'BARFOR',
  },
  BAVARIA: {
    value: 'BAVARIA',
    text: 'BAVARIA',
  },
  BAYLINER: {
    value: 'BAYLINER',
    text: 'BAYLINER',
  },
  BCS: {
    value: 'BCS',
    text: 'BCS',
  },
  BELLIER: {
    value: 'BELLIER',
    text: 'BELLIER',
  },
  BENALU: {
    value: 'BENALU',
    text: 'BENALU',
  },
  BENELLI: {
    value: 'BENELLI',
    text: 'BENELLI',
  },
  BENETEAU: {
    value: 'BENETEAU',
    text: 'BENETEAU',
  },
  BENTLEY: {
    value: 'BENTLEY',
    text: 'BENTLEY',
  },
  BERGER: {
    value: 'BERGER',
    text: 'BERGER',
  },
  BERTONE: {
    value: 'BERTONE',
    text: 'BERTONE',
  },
  BETA: {
    value: 'BETA',
    text: 'BETA',
  },
  BMW: {
    value: 'BMW',
    text: 'BMW',
  },
  BOMBARDIER: {
    value: 'BOMBARDIER',
    text: 'BOMBARDIER',
  },
  BOOM: {
    value: 'BOOM',
    text: 'BOOM',
  },
  BRAMMO: {
    value: 'BRAMMO',
    text: 'BRAMMO',
  },
  BRIXTON: {
    value: 'BRIXTON',
    text: 'BRIXTON',
  },
  BSC: {
    value: 'BSC',
    text: 'BSC',
  },
  BTM: {
    value: 'BTM',
    text: 'BTM',
  },
  BUCHER: {
    value: 'BUCHER',
    text: 'BUCHER',
  },
  BUELL: {
    value: 'BUELL',
    text: 'BUELL',
  },
  BUICK: {
    value: 'BUICK',
    text: 'BUICK',
  },
  BULTACO: {
    value: 'BULTACO',
    text: 'BULTACO',
  },
  BUNKER: {
    value: 'BUNKER',
    text: 'BUNKER',
  },
  BURSTNER: {
    value: 'BURSTNER',
    text: 'BURSTNER',
  },
  CADILLAC: {
    value: 'CADILLAC',
    text: 'CADILLAC',
  },
  CAGIVA: {
    value: 'CAGIVA',
    text: 'CAGIVA',
  },
  CALAFAT: {
    value: 'CALAFAT',
    text: 'CALAFAT',
  },
  CALIDAD: {
    value: 'CALIDAD',
    text: 'CALIDAD',
  },
  CAMION: {
    value: 'CAMION',
    text: 'CAMION',
  },
  'CAN-AM': {
    value: 'CAN-AM',
    text: 'CAN-AM',
  },
  CAPEADOR: {
    value: 'CAPEADOR',
    text: 'CAPEADOR',
  },
  CARAVELAIR: {
    value: 'CARAVELAIR',
    text: 'CARAVELAIR',
  },
  CARDONA: {
    value: 'CARDONA',
    text: 'CARDONA',
  },
  CARRARO: {
    value: 'CARRARO',
    text: 'CARRARO',
  },
  CASALINI: {
    value: 'CASALINI',
    text: 'CASALINI',
  },
  CASE: {
    value: 'CASE',
    text: 'CASE',
  },
  CATERPILLAR: {
    value: 'CATERPILLAR',
    text: 'CATERPILLAR',
  },
  'CF MOTO': {
    value: 'CF MOTO',
    text: 'CF MOTO',
  },
  CHALLENGER: {
    value: 'CHALLENGER',
    text: 'CHALLENGER',
  },
  CHANGJIANG: {
    value: 'CHANGJIANG',
    text: 'CHANGJIANG',
  },
  CHATENET: {
    value: 'CHATENET',
    text: 'CHATENET',
  },
  'CHATENET-SANTAN': {
    value: 'CHATENET-SANTAN',
    text: 'CHATENET-SANTAN',
  },
  CHEREAU: {
    value: 'CHEREAU',
    text: 'CHEREAU',
  },
  CHEVROLET: {
    value: 'CHEVROLET',
    text: 'CHEVROLET',
  },
  'CHEVROLET-GM': {
    value: 'CHEVROLET-GM',
    text: 'CHEVROLET-GM',
  },
  CHRYSLER: {
    value: 'CHRYSLER',
    text: 'CHRYSLER',
  },
  CHUANL: {
    value: 'CHUANL',
    text: 'CHUANL',
  },
  CIMAS: {
    value: 'CIMAS',
    text: 'CIMAS',
  },
  CITROEN: {
    value: 'CITROEN',
    text: 'CITROEN',
  },
  'CITY CAT': {
    value: 'CITY CAT',
    text: 'CITY CAT',
  },
  CLAAS: {
    value: 'CLAAS',
    text: 'CLAAS',
  },
  CLIPIC: {
    value: 'CLIPIC',
    text: 'CLIPIC',
  },
  'CODIGO ESPECIAL': {
    value: 'CODIGO ESPECIAL',
    text: 'CODIGO ESPECIAL',
  },
  COOLTRA: {
    value: 'COOLTRA',
    text: 'COOLTRA',
  },
  CORVETTE: {
    value: 'CORVETTE',
    text: 'CORVETTE',
  },
  'CPI MOTOR': {
    value: 'CPI MOTOR',
    text: 'CPI MOTOR',
  },
  CSR: {
    value: 'CSR',
    text: 'CSR',
  },
  CUALQUIER: {
    value: 'CUALQUIER',
    text: 'CUALQUIER',
  },
  CUALQUIERA: {
    value: 'CUALQUIERA',
    text: 'CUALQUIERA',
  },
  'D-TEC': {
    value: 'D-TEC',
    text: 'D-TEC',
  },
  DACIA: {
    value: 'DACIA',
    text: 'DACIA',
  },
  DAELIM: {
    value: 'DAELIM',
    text: 'DAELIM',
  },
  DAEWOO: {
    value: 'DAEWOO',
    text: 'DAEWOO',
  },
  'DAEWOO/CHEVROL': {
    value: 'DAEWOO/CHEVROL',
    text: 'DAEWOO/CHEVROL',
  },
  DAF: {
    value: 'DAF',
    text: 'DAF',
  },
  DAIHATSU: {
    value: 'DAIHATSU',
    text: 'DAIHATSU',
  },
  DAIMLER: {
    value: 'DAIMLER',
    text: 'DAIMLER',
  },
  DAK: {
    value: 'DAK',
    text: 'DAK',
  },
  DEMAG: {
    value: 'DEMAG',
    text: 'DEMAG',
  },
  DERBI: {
    value: 'DERBI',
    text: 'DERBI',
  },
  DESCONOCIDO: {
    value: 'DESCONOCIDO',
    text: 'DESCONOCIDO',
  },
  DEUTZ: {
    value: 'DEUTZ',
    text: 'DEUTZ',
  },
  DFSK: {
    value: 'DFSK',
    text: 'DFSK',
  },
  DODGE: {
    value: 'DODGE',
    text: 'DODGE',
  },
  DORTON: {
    value: 'DORTON',
    text: 'DORTON',
  },
  DS: {
    value: 'DS',
    text: 'DS',
  },
  DUCATI: {
    value: 'DUCATI',
    text: 'DUCATI',
  },
  DUE: {
    value: 'DUE',
    text: 'DUE',
  },
  DUMPER: {
    value: 'DUMPER',
    text: 'DUMPER',
  },
  EBRO: {
    value: 'EBRO',
    text: 'EBRO',
  },
  EFUN: {
    value: 'EFUN',
    text: 'EFUN',
  },
  EMBUGGY: {
    value: 'EMBUGGY',
    text: 'EMBUGGY',
  },
  ERAD: {
    value: 'ERAD',
    text: 'ERAD',
  },
  ERF: {
    value: 'ERF',
    text: 'ERF',
  },
  EUCAR: {
    value: 'EUCAR',
    text: 'EUCAR',
  },
  'FACTORY BIKE': {
    value: 'FACTORY BIKE',
    text: 'FACTORY BIKE',
  },
  FANTIC: {
    value: 'FANTIC',
    text: 'FANTIC',
  },
  FARESIN: {
    value: 'FARESIN',
    text: 'FARESIN',
  },
  FENDT: {
    value: 'FENDT',
    text: 'FENDT',
  },
  FERMEC: {
    value: 'FERMEC',
    text: 'FERMEC',
  },
  FERRARI: {
    value: 'FERRARI',
    text: 'FERRARI',
  },
  FIAT: {
    value: 'FIAT',
    text: 'FIAT',
  },
  'FIAT HITACHI': {
    value: 'FIAT HITACHI',
    text: 'FIAT HITACHI',
  },
  'FIAT-IVECO': {
    value: 'FIAT-IVECO',
    text: 'FIAT-IVECO',
  },
  FIATAGRI: {
    value: 'FIATAGRI',
    text: 'FIATAGRI',
  },
  FORD: {
    value: 'FORD',
    text: 'FORD',
  },
  FRUEHAUF: {
    value: 'FRUEHAUF',
    text: 'FRUEHAUF',
  },
  FURGON: {
    value: 'FURGON',
    text: 'FURGON',
  },
  FURGONETA: {
    value: 'FURGONETA',
    text: 'FURGONETA',
  },
  GALLOPER: {
    value: 'GALLOPER',
    text: 'GALLOPER',
  },
  'GAS-GAS': {
    value: 'GAS-GAS',
    text: 'GAS-GAS',
  },
  GILERA: {
    value: 'GILERA',
    text: 'GILERA',
  },
  GMC: {
    value: 'GMC',
    text: 'GMC',
  },
  GME: {
    value: 'GME',
    text: 'GME',
  },
  GOES: {
    value: 'GOES',
    text: 'GOES',
  },
  GOUPIL: {
    value: 'GOUPIL',
    text: 'GOUPIL',
  },
  GOVECS: {
    value: 'GOVECS',
    text: 'GOVECS',
  },
  GRANALU: {
    value: 'GRANALU',
    text: 'GRANALU',
  },
  GRECAV: {
    value: 'GRECAV',
    text: 'GRECAV',
  },
  GUHUR: {
    value: 'GUHUR',
    text: 'GUHUR',
  },
  GUILLEN: {
    value: 'GUILLEN',
    text: 'GUILLEN',
  },
  HAMMEL: {
    value: 'HAMMEL',
    text: 'HAMMEL',
  },
  HANGLONG: {
    value: 'HANGLONG',
    text: 'HANGLONG',
  },
  HANWAY: {
    value: 'HANWAY',
    text: 'HANWAY',
  },
  HAOTIAN: {
    value: 'HAOTIAN',
    text: 'HAOTIAN',
  },
  'HARLEY DAVIDSON': {
    value: 'HARLEY DAVIDSON',
    text: 'HARLEY DAVIDSON',
  },
  HONDA: {
    value: 'HONDA',
    text: 'HONDA',
  },
  HSUN: {
    value: 'HSUN',
    text: 'HSUN',
  },
  HUATIAN: {
    value: 'HUATIAN',
    text: 'HUATIAN',
  },
  HUAWIN: {
    value: 'HUAWIN',
    text: 'HUAWIN',
  },
  HUMMER: {
    value: 'HUMMER',
    text: 'HUMMER',
  },
  HUSABERG: {
    value: 'HUSABERG',
    text: 'HUSABERG',
  },
  HUSQVARNA: {
    value: 'HUSQVARNA',
    text: 'HUSQVARNA',
  },
  HYOSUNG: {
    value: 'HYOSUNG',
    text: 'HYOSUNG',
  },
  HYUNDAI: {
    value: 'HYUNDAI',
    text: 'HYUNDAI',
  },
  IBESTON: {
    value: 'IBESTON',
    text: 'IBESTON',
  },
  'IGM-MAYSE': {
    value: 'IGM-MAYSE',
    text: 'IGM-MAYSE',
  },
  IMOTO: {
    value: 'IMOTO',
    text: 'IMOTO',
  },
  INDETERMINADA: {
    value: 'INDETERMINADA',
    text: 'INDETERMINADA',
  },
  INDIAN: {
    value: 'INDIAN',
    text: 'INDIAN',
  },
  INFINITI: {
    value: 'INFINITI',
    text: 'INFINITI',
  },
  INNOCENTI: {
    value: 'INNOCENTI',
    text: 'INNOCENTI',
  },
  IPV: {
    value: 'IPV',
    text: 'IPV',
  },
  ISUZU: {
    value: 'ISUZU',
    text: 'ISUZU',
  },
  ITALCAR: {
    value: 'ITALCAR',
    text: 'ITALCAR',
  },
  ITALJET: {
    value: 'ITALJET',
    text: 'ITALJET',
  },
  IVECO: {
    value: 'IVECO',
    text: 'IVECO',
  },
  'IVECO-PEGASO': {
    value: 'IVECO-PEGASO',
    text: 'IVECO-PEGASO',
  },
  JAGUAR: {
    value: 'JAGUAR',
    text: 'JAGUAR',
  },
  'JAMES B': {
    value: 'JAMES B',
    text: 'JAMES B',
  },
  'JAWA-PENTA': {
    value: 'JAWA-PENTA',
    text: 'JAWA-PENTA',
  },
  JCB: {
    value: 'JCB',
    text: 'JCB',
  },
  JDM: {
    value: 'JDM',
    text: 'JDM',
  },
  'JDM-SIMPA': {
    value: 'JDM-SIMPA',
    text: 'JDM-SIMPA',
  },
  JEEP: {
    value: 'JEEP',
    text: 'JEEP',
  },
  'JEEP-CHRYSLER': {
    value: 'JEEP-CHRYSLER',
    text: 'JEEP-CHRYSLER',
  },
  'JEEP-VIASA': {
    value: 'JEEP-VIASA',
    text: 'JEEP-VIASA',
  },
  JINCHENG: {
    value: 'JINCHENG',
    text: 'JINCHENG',
  },
  JINLUN: {
    value: 'JINLUN',
    text: 'JINLUN',
  },
  JMSTAR: {
    value: 'JMSTAR',
    text: 'JMSTAR',
  },
  'JOHN DEERE': {
    value: 'JOHN DEERE',
    text: 'JOHN DEERE',
  },
  JONWAY: {
    value: 'JONWAY',
    text: 'JONWAY',
  },
  KAWASAKI: {
    value: 'KAWASAKI',
    text: 'KAWASAKI',
  },
  KEEWAY: {
    value: 'KEEWAY',
    text: 'KEEWAY',
  },
  KENROD: {
    value: 'KENROD',
    text: 'KENROD',
  },
  KIA: {
    value: 'KIA',
    text: 'KIA',
  },
  KINGDAY: {
    value: 'KINGDAY',
    text: 'KINGDAY',
  },
  KINLON: {
    value: 'KINLON',
    text: 'KINLON',
  },
  KINROAD: {
    value: 'KINROAD',
    text: 'KINROAD',
  },
  KIOTI: {
    value: 'KIOTI',
    text: 'KIOTI',
  },
  KNAUS: {
    value: 'KNAUS',
    text: 'KNAUS',
  },
  KOEGEL: {
    value: 'KOEGEL',
    text: 'KOEGEL',
  },
  KOMATSU: {
    value: 'KOMATSU',
    text: 'KOMATSU',
  },
  KRONE: {
    value: 'KRONE',
    text: 'KRONE',
  },
  KSR: {
    value: 'KSR',
    text: 'KSR',
  },
  KTM: {
    value: 'KTM',
    text: 'KTM',
  },
  KUBOTA: {
    value: 'KUBOTA',
    text: 'KUBOTA',
  },
  KYMCO: {
    value: 'KYMCO',
    text: 'KYMCO',
  },
  LADA: {
    value: 'LADA',
    text: 'LADA',
  },
  LAMBERET: {
    value: 'LAMBERET',
    text: 'LAMBERET',
  },
  'LAMBERET VEHÖCU': {
    value: 'LAMBERET VEHÖCU',
    text: 'LAMBERET VEHÖCU',
  },
  LAMBORGHINI: {
    value: 'LAMBORGHINI',
    text: 'LAMBORGHINI',
  },
  LAMBRETTA: {
    value: 'LAMBRETTA',
    text: 'LAMBRETTA',
  },
  LANCIA: {
    value: 'LANCIA',
    text: 'LANCIA',
  },
  'LAND ROVER': {
    value: 'LAND ROVER',
    text: 'LAND ROVER',
  },
  LANDINI: {
    value: 'LANDINI',
    text: 'LANDINI',
  },
  LANVERTTI: {
    value: 'LANVERTTI',
    text: 'LANVERTTI',
  },
  LAVERDA: {
    value: 'LAVERDA',
    text: 'LAVERDA',
  },
  LDV: {
    value: 'LDV',
    text: 'LDV',
  },
  LDY: {
    value: 'LDY',
    text: 'LDY',
  },
  'LECIÑENA SA': {
    value: 'LECIÑENA SA',
    text: 'LECIÑENA SA',
  },
  LECIÑENA: {
    value: 'LECIÑENA',
    text: 'LECIÑENA',
  },
  LECITRAILER: {
    value: 'LECITRAILER',
    text: 'LECITRAILER',
  },
  LECSOR: {
    value: 'LECSOR',
    text: 'LECSOR',
  },
  LEMEV: {
    value: 'LEMEV',
    text: 'LEMEV',
  },
  LEONART: {
    value: 'LEONART',
    text: 'LEONART',
  },
  LEXUS: {
    value: 'LEXUS',
    text: 'LEXUS',
  },
  LEYLAND: {
    value: 'LEYLAND',
    text: 'LEYLAND',
  },
  LIEBHERR: {
    value: 'LIEBHERR',
    text: 'LIEBHERR',
  },
  LIFAN: {
    value: 'LIFAN',
    text: 'LIFAN',
  },
  LIGIER: {
    value: 'LIGIER',
    text: 'LIGIER',
  },
  LINCOLN: {
    value: 'LINCOLN',
    text: 'LINCOLN',
  },
  LINGYUN: {
    value: 'LINGYUN',
    text: 'LINGYUN',
  },
  LINHAI: {
    value: 'LINHAI',
    text: 'LINHAI',
  },
  LINTEX: {
    value: 'LINTEX',
    text: 'LINTEX',
  },
  LML: {
    value: 'LML',
    text: 'LML',
  },
  'LOHR IBERICA S': {
    value: 'LOHR IBERICA S',
    text: 'LOHR IBERICA S',
  },
  LOTUS: {
    value: 'LOTUS',
    text: 'LOTUS',
  },
  'M-A': {
    value: 'M-A',
    text: 'M-A',
  },
  MACBOR: {
    value: 'MACBOR',
    text: 'MACBOR',
  },
  MAHINDRA: {
    value: 'MAHINDRA',
    text: 'MAHINDRA',
  },
  MALAGUTI: {
    value: 'MALAGUTI',
    text: 'MALAGUTI',
  },
  MAN: {
    value: 'MAN',
    text: 'MAN',
  },
  MANITOU: {
    value: 'MANITOU',
    text: 'MANITOU',
  },
  MASERATTI: {
    value: 'MASERATTI',
    text: 'MASERATTI',
  },
  MASH: {
    value: 'MASH',
    text: 'MASH',
  },
  MASSEY: {
    value: 'MASSEY',
    text: 'MASSEY',
  },
  'MASSEY FERGUSON': {
    value: 'MASSEY FERGUSON',
    text: 'MASSEY FERGUSON',
  },
  MAXUS: {
    value: 'MAXUS',
    text: 'MAXUS',
  },
  MAYBACH: {
    value: 'MAYBACH',
    text: 'MAYBACH',
  },
  MAZDA: {
    value: 'MAZDA',
    text: 'MAZDA',
  },
  MBK: {
    value: 'MBK',
    text: 'MBK',
  },
  MCC: {
    value: 'MCC',
    text: 'MCC',
  },
  MCCORMICK: {
    value: 'MCCORMICK',
    text: 'MCCORMICK',
  },
  MECATECNO: {
    value: 'MECATECNO',
    text: 'MECATECNO',
  },
  MERCEDES: {
    value: 'MERCEDES',
    text: 'MERCEDES',
  },
  'MERCEDES-BENZ': {
    value: 'MERCEDES-BENZ',
    text: 'MERCEDES-BENZ',
  },
  MERCURY: {
    value: 'MERCURY',
    text: 'MERCURY',
  },
  MG: {
    value: 'MG',
    text: 'MG',
  },
  MICROCAR: {
    value: 'MICROCAR',
    text: 'MICROCAR',
  },
  MICROVETT: {
    value: 'MICROVETT',
    text: 'MICROVETT',
  },
  MINI: {
    value: 'MINI',
    text: 'MINI',
  },
  MIROFRET: {
    value: 'MIROFRET',
    text: 'MIROFRET',
  },
  MITSUBISHI: {
    value: 'MITSUBISHI',
    text: 'MITSUBISHI',
  },
  MITT: {
    value: 'MITT',
    text: 'MITT',
  },
  MONCAYO: {
    value: 'MONCAYO',
    text: 'MONCAYO',
  },
  MONDIAL: {
    value: 'MONDIAL',
    text: 'MONDIAL',
  },
  MONTENEGRO: {
    value: 'MONTENEGRO',
    text: 'MONTENEGRO',
  },
  MONTESA: {
    value: 'MONTESA',
    text: 'MONTESA',
  },
  MORGAN: {
    value: 'MORGAN',
    text: 'MORGAN',
  },
  MORINI: {
    value: 'MORINI',
    text: 'MORINI',
  },
  MORRIS: {
    value: 'MORRIS',
    text: 'MORRIS',
  },
  'MOTO GUZZI': {
    value: 'MOTO GUZZI',
    text: 'MOTO GUZZI',
  },
  MOTOCICLETAS: {
    value: 'MOTOCICLETAS',
    text: 'MOTOCICLETAS',
  },
  MOTOGAC: {
    value: 'MOTOGAC',
    text: 'MOTOGAC',
  },
  MOTORHISPANIA: {
    value: 'MOTORHISPANIA',
    text: 'MOTORHISPANIA',
  },
  MTR: {
    value: 'MTR',
    text: 'MTR',
  },
  MULTICAR: {
    value: 'MULTICAR',
    text: 'MULTICAR',
  },
  'MV AUGUSTA': {
    value: 'MV AUGUSTA',
    text: 'MV AUGUSTA',
  },
  'MX MOTOR': {
    value: 'MX MOTOR',
    text: 'MX MOTOR',
  },
  'NEW HOLLAND': {
    value: 'NEW HOLLAND',
    text: 'NEW HOLLAND',
  },
  NISSAN: {
    value: 'NISSAN',
    text: 'NISSAN',
  },
  OPEL: {
    value: 'OPEL',
    text: 'OPEL',
  },
  OSSA: {
    value: 'OSSA',
    text: 'OSSA',
  },
  PACTON: {
    value: 'PACTON',
    text: 'PACTON',
  },
  PASQUALI: {
    value: 'PASQUALI',
    text: 'PASQUALI',
  },
  PEGASO: {
    value: 'PEGASO',
    text: 'PEGASO',
  },
  PEUGEOT: {
    value: 'PEUGEOT',
    text: 'PEUGEOT',
  },
  PGO: {
    value: 'PGO',
    text: 'PGO',
  },
  PIAGGIO: {
    value: 'PIAGGIO',
    text: 'PIAGGIO',
  },
  'PIAGGIO-VESPA': {
    value: 'PIAGGIO-VESPA',
    text: 'PIAGGIO-VESPA',
  },
  PIONEER: {
    value: 'PIONEER',
    text: 'PIONEER',
  },
  PLACAS: {
    value: 'PLACAS',
    text: 'PLACAS',
  },
  POLARIS: {
    value: 'POLARIS',
    text: 'POLARIS',
  },
  PONTIAC: {
    value: 'PONTIAC',
    text: 'PONTIAC',
  },
  PORSCHE: {
    value: 'PORSCHE',
    text: 'PORSCHE',
  },
  'PRIM-BALL': {
    value: 'PRIM-BALL',
    text: 'PRIM-BALL',
  },
  PUCH: {
    value: 'PUCH',
    text: 'PUCH',
  },
  QINGQI: {
    value: 'QINGQI',
    text: 'QINGQI',
  },
  RANGER: {
    value: 'RANGER',
    text: 'RANGER',
  },
  RAVO: {
    value: 'RAVO',
    text: 'RAVO',
  },
  REMOLQUE: {
    value: 'REMOLQUE',
    text: 'REMOLQUE',
  },
  RENAULT: {
    value: 'RENAULT',
    text: 'RENAULT',
  },
  REWACO: {
    value: 'REWACO',
    text: 'REWACO',
  },
  RHON: {
    value: 'RHON',
    text: 'RHON',
  },
  RIDE: {
    value: 'RIDE',
    text: 'RIDE',
  },
  RIEJU: {
    value: 'RIEJU',
    text: 'RIEJU',
  },
  RIVOLTA: {
    value: 'RIVOLTA',
    text: 'RIVOLTA',
  },
  RIYA: {
    value: 'RIYA',
    text: 'RIYA',
  },
  'ROLLS-ROYCE': {
    value: 'ROLLS-ROYCE',
    text: 'ROLLS-ROYCE',
  },
  ROVER: {
    value: 'ROVER',
    text: 'ROVER',
  },
  'ROVER-AUSTIN': {
    value: 'ROVER-AUSTIN',
    text: 'ROVER-AUSTIN',
  },
  'ROYAL CLASSIC': {
    value: 'ROYAL CLASSIC',
    text: 'ROYAL CLASSIC',
  },
  'ROYAL ENFIELD': {
    value: 'ROYAL ENFIELD',
    text: 'ROYAL ENFIELD',
  },
  SAAB: {
    value: 'SAAB',
    text: 'SAAB',
  },
  SAMADA: {
    value: 'SAMADA',
    text: 'SAMADA',
  },
  SAME: {
    value: 'SAME',
    text: 'SAME',
  },
  SAMRO: {
    value: 'SAMRO',
    text: 'SAMRO',
  },
  SANGLAS: {
    value: 'SANGLAS',
    text: 'SANGLAS',
  },
  SANTANA: {
    value: 'SANTANA',
    text: 'SANTANA',
  },
  'SANYANG-SYM': {
    value: 'SANYANG-SYM',
    text: 'SANYANG-SYM',
  },
  SANYOU: {
    value: 'SANYOU',
    text: 'SANYOU',
  },
  SAVA: {
    value: 'SAVA',
    text: 'SAVA',
  },
  SCANIA: {
    value: 'SCANIA',
    text: 'SCANIA',
  },
  SCHMIDT: {
    value: 'SCHMIDT',
    text: 'SCHMIDT',
  },
  SCHMITZ: {
    value: 'SCHMITZ',
    text: 'SCHMITZ',
  },
  SCOMADI: {
    value: 'SCOMADI',
    text: 'SCOMADI',
  },
  SCUTUM: {
    value: 'SCUTUM',
    text: 'SCUTUM',
  },
  SEAT: {
    value: 'SEAT',
    text: 'SEAT',
  },
  SETTER: {
    value: 'SETTER',
    text: 'SETTER',
  },
  SHERCO: {
    value: 'SHERCO',
    text: 'SHERCO',
  },
  SHINERAY: {
    value: 'SHINERAY',
    text: 'SHINERAY',
  },
  SIAMOTO: {
    value: 'SIAMOTO',
    text: 'SIAMOTO',
  },
  SIMCA: {
    value: 'SIMCA',
    text: 'SIMCA',
  },
  SIMPA: {
    value: 'SIMPA',
    text: 'SIMPA',
  },
  SKODA: {
    value: 'SKODA',
    text: 'SKODA',
  },
  SKYTEAM: {
    value: 'SKYTEAM',
    text: 'ABASKYTEAMRTH',
  },
  SLOT: {
    value: 'SLOT',
    text: 'SLOT',
  },
  SMART: {
    value: 'SMART',
    text: 'SMART',
  },
  'SOR IBERICA': {
    value: 'SOR IBERICA',
    text: 'SOR IBERICA',
  },
  SPITZER: {
    value: 'SPITZER',
    text: 'SPITZER',
  },
  SSANGYONG: {
    value: 'SSANGYONG',
    text: 'SSANGYONG',
  },
  SUBARU: {
    value: 'SUBARU',
    text: 'SUBARU',
  },
  SUMCO: {
    value: 'SUMCO',
    text: 'SUMCO',
  },
  'SUN ROLLER': {
    value: 'SUN ROLLER',
    text: 'SUN ROLLER',
  },
  SUZUKI: {
    value: 'SUZUKI',
    text: 'SUZUKI',
  },
  'SUZUKI-SANTANA': {
    value: 'SUZUKI-SANTANA',
    text: 'SUZUKI-SANTANA',
  },
  SYM: {
    value: 'SYM',
    text: 'SYM',
  },
  TALBOT: {
    value: 'TALBOT',
    text: 'TALBOT',
  },
  TASSO: {
    value: 'TASSO',
    text: 'TASSO',
  },
  TATA: {
    value: 'TATA',
    text: 'TATA',
  },
  'TATA-TELCO': {
    value: 'TATA-TELCO',
    text: 'TATA-TELCO',
  },
  TBQ: {
    value: 'TBQ',
    text: 'TBQ',
  },
  TESLA: {
    value: 'TESLA',
    text: 'TESLA',
  },
  TGB: {
    value: 'TGB',
    text: 'TGB',
  },
  THINK: {
    value: 'THINK',
    text: 'THINK',
  },
  TISVOL: {
    value: 'TISVOL',
    text: 'TISVOL',
  },
  TM: {
    value: 'TM',
    text: 'TM',
  },
  'TNT MOTOR': {
    value: 'TNT MOTOR',
    text: 'TNT MOTOR',
  },
  'TODOS TODOS': {
    value: 'TODOS TODOS',
    text: 'TODOS TODOS',
  },
  TORO: {
    value: 'TORO',
    text: 'TORO',
  },
  TOYOTA: {
    value: 'TOYOTA',
    text: 'TOYOTA',
  },
  TRACTOR: {
    value: 'TRACTOR',
    text: 'TRACTOR',
  },
  TRIUMPH: {
    value: 'TRIUMPH',
    text: 'TRIUMPH',
  },
  TURBHO: {
    value: 'TURBHO',
    text: 'TURBHO',
  },
  TURISMOS: {
    value: 'TURISMOS',
    text: 'TURISMOS',
  },
  UMM: {
    value: 'UMM',
    text: 'UMM',
  },
  URO: {
    value: 'URO',
    text: 'URO',
  },
  'V AGRICOLA': {
    value: 'V AGRICOLA',
    text: 'V AGRICOLA',
  },
  'V INDUSTRIAL': {
    value: 'V INDUSTRIAL',
    text: 'V INDUSTRIAL',
  },
  VALMET: {
    value: 'VALMET',
    text: 'VALMET',
  },
  VALTRA: {
    value: 'VALTRA',
    text: 'VALTRA',
  },
  VAUXHALL: {
    value: 'VAUXHALL',
    text: 'VAUXHALL',
  },
  VAZ: {
    value: 'VAZ',
    text: 'VAZ',
  },
  VECTRIX: {
    value: 'VECTRIX',
    text: 'VECTRIX',
  },
  VESPA: {
    value: 'VESPA',
    text: 'VESPA',
  },
  VESPINO: {
    value: 'VESPINO',
    text: 'VESPINO',
  },
  VEXEL: {
    value: 'VEXEL',
    text: 'VEXEL',
  },
  VICTORY: {
    value: 'VICTORY',
    text: 'VICTORY',
  },
  VOLKSWAGEN: {
    value: 'VOLKSWAGEN',
    text: 'VOLKSWAGEN',
  },
  VOLTA: {
    value: 'VOLTA',
    text: 'VOLTA',
  },
  VOLVO: {
    value: 'VOLVO',
    text: 'VOLVO',
  },
  VUELTA: {
    value: 'VUELTA',
    text: 'VUELTA',
  },
  WANGYE: {
    value: 'WANGYE',
    text: 'WANGYE',
  },
  'WILD WEST': {
    value: 'WILD WEST',
    text: 'WILD WEST',
  },
  WILDLANDER: {
    value: 'WILDLANDER',
    text: 'WILDLANDER',
  },
  WILLYS: {
    value: 'WILLYS',
    text: 'WILLYS',
  },
  WOTTAN: {
    value: 'WOTTAN',
    text: 'WOTTAN',
  },
  'WYLLIS-VIASA': {
    value: 'WYLLIS-VIASA',
    text: 'WYLLIS-VIASA',
  },
  XINLING: {
    value: 'XINLING',
    text: 'XINLING',
  },
  YAMAHA: {
    value: 'YAMAHA',
    text: 'YAMAHA',
  },
  YANMAR: {
    value: 'YANMAR',
    text: 'YANMAR',
  },
  YIYING: {
    value: 'YIYING',
    text: 'YIYING',
  },
  ZASTAVA: {
    value: 'ZASTAVA',
    text: 'ZASTAVA',
  },
  ZERO: {
    value: 'ZERO',
    text: 'ZERO',
  },
  ZETOR: {
    value: 'ZETOR',
    text: 'ZETOR',
  },
  ZHONGYU: {
    value: 'ZHONGYU',
    text: 'ZHONGYU',
  },
  ZNEN: {
    value: 'ZNEN',
    text: 'ZNEN',
  },
  ZONGSHEN: {
    value: 'ZONGSHEN',
    text: 'ZONGSHEN',
  },
  ZONTES: {
    value: 'ZONTES',
    text: 'ZONTES',
  },
};

const faultTypesMeanings = (t: TFunction<string[] | string>) => ({
  0: t('common:common-text.no-starting'),
  1: t('common:common-text.puncture'),
  2: t('common:common-text.battery'),
  3: t('common:common-text.keys'),
  4: t('common:common-text.gas'),
  5: t('common:common-text.other-fault'),
});

const NOTIFICATION_TYPES: { [key: string]: { value: string } } = {
  CRANE_POSITIONED: { value: 'CRANE_POSITIONED' },
  CRANE_ARRIVED: { value: 'CRANE_ARRIVED' },
  ASSISTANCE_FINISHED: { value: 'ASSISTANCE_FINISHED' },
  DELIVERY_NOTE_AVAILABLE: { value: 'DELIVERY_NOTE_AVAILABLE' },
  SURVEY_AVAILABLE: { value: 'SURVEY_AVAILABLE' },
  OPEN: {
    value: 'OPEN',
  },
};

const redBatteryLightMeanings = (t: TFunction<string[] | string>) => ({
  0: t('common:label-inputs.negative-response'),
  1: t('common:label-inputs.affirmative-response'),
  2: t('common:label-inputs.unknown-response'),
});

const PHONE_CONTACT_NUMBER = '900 101 399';

const CRANE_LOCATION_STATE_CODES: { [key: string]: CraneTrackingStep } = {
  '01': 1, // Grúa geolocalizada
  '99': 2, // Geo de grúa recibida
  '03': 3, // Grúa ha llegado, al parecer
  '07': 4, // Asistencia finalizada
  '60': 4, // Tiempo de espera sin geo excedido
};

const COMPANIES_WITH_WORKSHOP = ['00000002', '00000016'];

const INSURANCE_COMPANIES: { [key: string]: InsuranceCompany } = {
  '00000001': {
    value: '00000001',
    text: 'S.BILBAO',
    img: images.segurosBilbao,
    alt: 'segurosBilbao',
    nameCode: 'Seguros Bilbao',
    theme: segurosBilbaoTheme,
    phone: '913 939 069',
    webParam: 'bilbao',
  },
  '00000002': {
    value: '00000002',
    text: 'CATALANA',
    img: images.catalanaOccidente,
    alt: 'catalanaOccidente',
    nameCode: 'Catalana Occidente Seguros',
    theme: catalanaOccidenteTheme,
    phone: '913 939 064',
    legal: 'https://www.occident.com/aviso-legal',
    privacy: 'https://www.occident.com/politica-privacidad',
    cookies: 'https://www.occident.com/politica-de-cookies',
    webParam: 'occident',
  },
  '00000006': {
    value: '00000006',
    text: 'GES',
    img: images.gesSeguros,
    nameCode: 'Ges Seguros',
    alt: 'gesSeguros',
    theme: gesSegurosTheme,
    phone: '913 933 269',
    webParam: 'ges',
  },
  '00000007': {
    value: '00000007',
    text: 'UNION ALCOYANA',
    img: images.unionAlcoyana,
    alt: 'unionAlcoyana',
    theme: unionAlcoyanaTheme,
    phone: '913 939 043',
    webParam: 'alcoyana',
  },
  '00000010': {
    value: '00000010',
    text: 'MGS',
    img: images.mgs,
    alt: 'mgsros',
    theme: mgsTheme,
    phone: '917 572 404',
    webParam: 'mgs',
  },
  '00000011': {
    value: '00000011',
    text: 'HELVETIA',
    img: images.helvetia,
    alt: 'helvetia',
    theme: helvetiaTheme,
    phone: '913 939 057',
    webParam: 'helvetia',
  },
  '00000016': {
    value: '00000016',
    text: 'ASITUR ASISTENCIA, S.A',
    nameCode: 'Asitur S.A.',
    img: images.logo,
    alt: 'Asitur logo',
    theme: theme,
    phone: PHONE_CONTACT_NUMBER,
    webParam: 'asitur',
  },
  '00000020': {
    value: '00000020',
    text: 'PLUS ULTRA',
    img: images.plusUltra,
    alt: 'plusUltra',
    theme: plusUltraTheme,
    phone: '913 933 192',
    webParam: 'plusultra',
  },
  '00000025': {
    value: '00000025',
    text: 'REALE',
    img: images.reale,
    alt: 'REALE',
    theme: realeTheme,
    phone: '918 073 729',
    webParam: 'reale',
  },
  '00000045': {
    value: '00000045',
    text: 'FIATC SEGUROS ',
    img: images.fiatcSeguros,
    alt: 'FIATC',
    theme: fiatcTheme,
    phone: '917 572 537',
    webParam: 'fiatc',
  },
  '00000060': {
    value: '00000060',
    text: 'CASER SEGUROS',
    img: images.caserSeguros,
    alt: 'CASER',
    theme: caserTheme,
    phone: '900 101 399',
    webParam: 'caser',
  },
};

const ALPHABET = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export type ProviderLogo = {
  img: string;
  alt: string;
  name?: string;
};

export type ProviderLogos = {
  [key: string]: ProviderLogo;
};

export const DUMMY_IDENTIFIER = '&ZD547W30A';

export {
  SPECIALS_PLATES,
  faultTypesMeanings,
  redBatteryLightMeanings,
  PHONE_CONTACT_NUMBER,
  INSURANCE_COMPANIES,
  CRANE_LOCATION_STATE_CODES,
  MANUFACTERS_BRANDS,
  ALPHABET,
  getSupportedLanguages,
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  NOTIFICATION_TYPES,
  DATE_FORMAT,
  TIME_FORMAT,
  TIMEZONE,
  COMPANIES_WITH_WORKSHOP,
  ASITUR_CODE,
};
